import { Box, Typography } from '@mui/material';

import ErrorIcon from '../Images/ErrorIcon';
import type { HelperTextProps } from './HelperText.model';
import useStyles from './HelperText.styles';

const HelperText = (props: HelperTextProps): JSX.Element => {
  const { classes } = useStyles();
  return (
    <Box
      className={`${classes.helperTextContainer} ${props.error ? 'error-label' : 'helper-text-label'}`.trim()}
    >
      {props.error && (
        <Box component="span" className={classes.errorIconContainer}>
          <ErrorIcon />
        </Box>
      )}
      <Typography
        variant="small_body_medium"
        data-testid={
          props.error
            ? `${props.testId}-error-label`
            : `${props.testId}-helper-text-label`
        }
      >
        {props.label}
      </Typography>
      {!props.error && props.showCharacterCount && (
        <Typography
          variant="small_body_medium"
          data-testid={`${props.testId}-character-count`}
          className="characterCount"
        >
          {`${props.currentCharacterCount}/${props.maxCharacterCount}`}
        </Typography>
      )}
    </Box>
  );
};

export default HelperText;
